import React from 'react'

type Props = {
  url: string | undefined | null
}

export const RenderExternalScript = (props: Props) => {
  // eslint-disable-next-line @next/next/no-sync-scripts
  return props.url ? <script src={props.url}></script> : null
}
